import PropTypes from "prop-types"
import React from "react"

import Form from "src/components/Form"
import HeadingSectionHeader from "src/components/Heading/HeadingSectionHeader"
import Loader from "src/components/Loader"
import StripeConnectPayouts from "src/components/StripeConnect/StripeConnectPayouts"

const PayoutsTab = ({
  isSessionLoading,
  onboardingRequiredFieldsComplete,
  sessionError,
  stripeConnectInstance,
}) => {
  return (
    <div className="flex justify-center">
      <div className="card w-full shadow-base 2xl:w-1/2">
        {isSessionLoading ? (
          <Loader />
        ) : sessionError ? (
          <Form.Error>
            {sessionError.message ||
              "Failed to load account settings. Please try again."}
          </Form.Error>
        ) : onboardingRequiredFieldsComplete ? (
          <StripeConnectPayouts stripeConnectInstance={stripeConnectInstance} />
        ) : (
          <div className="flex flex-col space-y-4 py-8 text-center">
            <HeadingSectionHeader>
              Complete Account Setup Required
            </HeadingSectionHeader>
            <div className="flex flex-col justify-center space-y-2 p-4">
              <p className="text-gray-600">
                You need to complete your Stripe account onboarding before you
                can manage payouts.
              </p>
              <p className="text-gray-500">
                Please visit the Bank tab to complete your account setup first.
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

PayoutsTab.propTypes = {
  stripeConnectInstance: PropTypes.object,
  onboardingRequiredFieldsComplete: PropTypes.bool,
  isSessionLoading: PropTypes.bool.isRequired,
  sessionError: PropTypes.object,
}

export default PayoutsTab
